<template>
  <div class="layout-panoramica">
    <v-main>
      <div class="navy layout-panoramica-card">
        <panoramica-status-header></panoramica-status-header>
        <div class="layout-panoramica-body">
          <transition name="layout-panoramica-focus-exit" type="transition">
            <v-btn
              v-if="panoramicaFocusActive"
              icon
              small
              outlined
              color="secondary"
              title="Esci dal focus"
              class="layout-panoramica-focus-exit animation-soft-breathe"
              @click="toggleAllColumns"
            >
              <v-icon small>fullscreen_exit</v-icon>
            </v-btn>
          </transition>

          <transition name="layout-panoramica-toolbar">
            <div
              v-if="!panoramicaFocusActive"
              class="layout-panoramica-side-toolbar navy darken-3"
            >
            <v-btn
              icon
              :outlined="!svincolatiCollapsed"
              :color="svincolatiCollapsed ? 'primary' : 'primary'"
              title="Svincolati"
              class="layout-panoramica-side-toolbar-btn"
              @click="toggleColumn('svincolatiCollapsed')"
            >
              <v-icon small>groups</v-icon>
            </v-btn>
            <v-btn
              icon
              :outlined="!planCollapsed"
              :color="planCollapsed ? 'primary' : 'primary'"
              title="Pianificazione"
              class="layout-panoramica-side-toolbar-btn"
              @click="toggleColumn('planCollapsed')"
            >
              <v-icon small>paid</v-icon>
            </v-btn>
            <v-badge
              content="NEW"
              color="error"
              offset-x="20"
              offset-y="8"
              overlap
              class="layout-panoramica-side-toolbar-badge layout-panoramica-side-toolbar-badge-new"
            >
              <v-btn
                icon
                :outlined="!partecipantiCollapsed"
                :color="partecipantiCollapsed ? 'primary' : 'primary'"
                title="Partecipanti"
                class="layout-panoramica-side-toolbar-btn"
                @click="toggleColumn('partecipantiCollapsed')"
              >
                <v-icon small>people_alt</v-icon>
              </v-btn>
            </v-badge>
            <v-badge
              :value="showUnreadChatMessagesBadge"
              :content="unreadChatMessages"
              color="error"
              overlap
              class="layout-panoramica-side-toolbar-badge"
            >
              <v-btn
                icon
                :outlined="!chatCollapsed"
                :color="chatCollapsed ? 'primary' : 'primary'"
                title="Chat"
                class="layout-panoramica-side-toolbar-btn"
                @click="toggleColumn('chatCollapsed')"
              >
                <v-icon small>forum</v-icon>
              </v-btn>
            </v-badge>

            <div class="layout-panoramica-side-toolbar-bottom">
              <v-divider
                class="layout-panoramica-side-toolbar-divider"
              ></v-divider>
              <v-btn
                icon
                :outlined="panoramicaFocusActive"
                :color="panoramicaFocusActive ? 'secondary' : 'secondary'"
                :title="toggleAllColumnsTitle"
                class="layout-panoramica-side-toolbar-btn"
                @click="toggleAllColumns"
              >
                <v-icon small>{{ toggleAllColumnsIcon }}</v-icon>
              </v-btn>
            </div>
            </div>
          </transition>

          <div
            class="layout-panoramica-side-panel layout-panoramica-svincolati-chat navy darken-2"
            :class="{
              collapsed: svincolatiCollapsed && chatCollapsed,
              'layout-panoramica-svincolati-chat--split':
                !svincolatiCollapsed && !chatCollapsed,
            }"
          >
            <section
              v-if="!svincolatiCollapsed"
              class="layout-panoramica-svincolati-chat-section layout-panoramica-svincolati"
            >
              <asta-svincolati showTitle small-calciatori></asta-svincolati>
            </section>

            <section
              v-if="!chatCollapsed"
              class="layout-panoramica-svincolati-chat-section layout-panoramica-chat"
            >
              <div class="layout-panoramica-chat-content">
                <div
                  class="titolo navy--text text--lighten-2 font-hemi-head"
                >
                  Chat
                </div>
                <div class="layout-panoramica-chat-messages">
                  <asta-chat-messages></asta-chat-messages>
                </div>
                <div class="layout-panoramica-chat-input">
                  <asta-chat-input></asta-chat-input>
                </div>
              </div>
            </section>
          </div>

          <div
            class="layout-panoramica-side-panel layout-panoramica-plan navy darken-2"
            :class="{ collapsed: planCollapsed }"
          >
            <asta-plan
              v-if="!planCollapsed"
              showTitle
              :show-button-rose="false"
              class="layout-panoramica-plan-content"
            ></asta-plan>
          </div>

          <lista-tavolo :collapsed="partecipantiCollapsed"></lista-tavolo>

          <rose-lega
            show-title
            :squadra-menu-context="Constants.SQUADRA_TAVOLO_MENU_CONTEXT.PANORAMICA"
          ></rose-lega>
        </div>
      </div>
    </v-main>
  </div>
</template>

<script>
import RoseLega from "../RoseLega";
import AstaSvincolati from "../AstaSvincolati";
import AstaPlan from "../AstaPlan";
import AstaChatMessages from "../AstaChatMessages";
import AstaChatInput from "../AstaChatInput";
import PanoramicaStatusHeader from "../common/PanoramicaStatusHeader";
import ListaTavolo from "../common/ListaTavolo";
import mixins from "../../js/mixins";
import Vuex from "vuex";
import Constants from "../../js/constants";
import db from "../../js/db";

const defaultPanoramicaColumns = {
  svincolatiCollapsed: false,
  planCollapsed: false,
  chatCollapsed: true,
  partecipantiCollapsed: true,
};

function getStoredPanoramicaColumns() {
  const storedColumns = localStorage.getItem(Constants.LS_PANORAMICA_COLUMNS);
  if (!storedColumns) {
    return defaultPanoramicaColumns;
  }

  try {
    return {
      ...defaultPanoramicaColumns,
      ...JSON.parse(storedColumns),
    };
  } catch (e) {
    return defaultPanoramicaColumns;
  }
}

export default {
  name: "layout-panoramica",
  mixins: [mixins],
  components: {
    AstaChatInput,
    AstaChatMessages,
    AstaPlan,
    AstaSvincolati,
    RoseLega,
    PanoramicaStatusHeader,
    ListaTavolo,
  },
  data() {
    const storedColumns = getStoredPanoramicaColumns();
    return {
      svincolatiCollapsed: storedColumns.svincolatiCollapsed,
      planCollapsed: storedColumns.planCollapsed,
      chatCollapsed: storedColumns.chatCollapsed,
      partecipantiCollapsed: storedColumns.partecipantiCollapsed,
      lastSeenChatMessageCount: 0,
      skipSavePanoramicaColumns: false,
      focusModeActive: false,
    };
  },
  mounted() {
    console.log("--> LayoutPanoramica ready.");
    this.markChatMessagesAsSeen();
    this.emitPanoramicaFocus();
  },
  destroyed() {
    console.log("<-- LayoutPanoramica destroyed.");
    db.emit("panoramicaFocus", false);
  },
  computed: {
    ...Vuex.mapGetters(["asta_messages"]),
    unreadChatMessages() {
      return Math.max(
        this.asta_messages.length - this.lastSeenChatMessageCount,
        0
      );
    },
    showUnreadChatMessagesBadge() {
      return this.chatCollapsed && this.unreadChatMessages > 0;
    },
    panoramicaFocusActive() {
      return this.focusModeActive;
    },
    toggleAllColumnsIcon() {
      return this.panoramicaFocusActive ? "fullscreen_exit" : "fullscreen";
    },
    toggleAllColumnsTitle() {
      return this.panoramicaFocusActive
        ? "Ripristina pannelli preferiti"
        : "Focus rose e partecipanti";
    },
  },
  watch: {
    panoramicaFocusActive() {
      this.emitPanoramicaFocus();
    },
    svincolatiCollapsed() {
      this.savePanoramicaColumns();
    },
    planCollapsed() {
      this.savePanoramicaColumns();
    },
    chatCollapsed(collapsed) {
      this.savePanoramicaColumns();
      if (!collapsed) {
        this.markChatMessagesAsSeen();
      }
    },
    partecipantiCollapsed() {
      this.savePanoramicaColumns();
    },
    asta_messages() {
      if (!this.chatCollapsed) {
        this.markChatMessagesAsSeen();
      }
    },
  },
  methods: {
    markChatMessagesAsSeen() {
      this.lastSeenChatMessageCount = this.asta_messages.length;
    },
    emitPanoramicaFocus() {
      db.emit("panoramicaFocus", this.panoramicaFocusActive);
    },
    toggleColumn(column) {
      this.focusModeActive = false;
      this[column] = !this[column];
    },
    savePanoramicaColumns() {
      if (this.skipSavePanoramicaColumns) {
        return;
      }
      localStorage.setItem(
        Constants.LS_PANORAMICA_COLUMNS,
        JSON.stringify({
          svincolatiCollapsed: this.svincolatiCollapsed,
          planCollapsed: this.planCollapsed,
          chatCollapsed: this.chatCollapsed,
          partecipantiCollapsed: this.partecipantiCollapsed,
        })
      );
    },
    currentColumns() {
      return {
        svincolatiCollapsed: this.svincolatiCollapsed,
        planCollapsed: this.planCollapsed,
        chatCollapsed: this.chatCollapsed,
        partecipantiCollapsed: this.partecipantiCollapsed,
      };
    },
    hasVisibleColumn(columns) {
      return (
        columns &&
        (!columns.svincolatiCollapsed ||
          !columns.planCollapsed ||
          !columns.chatCollapsed ||
          !columns.partecipantiCollapsed)
      );
    },
    getColumnsToRestore() {
      const storedColumnsToRestore = localStorage.getItem(
        Constants.LS_PANORAMICA_COLUMNS_RESTORE
      );

      try {
        const columnsToRestore = {
          ...defaultPanoramicaColumns,
          ...JSON.parse(storedColumnsToRestore),
        };

        if (this.hasVisibleColumn(columnsToRestore)) {
          return columnsToRestore;
        }
      } catch (e) {}

      return defaultPanoramicaColumns;
    },
    saveColumnsToRestore(columns) {
      if (!this.hasVisibleColumn(columns)) {
        return;
      }

      localStorage.setItem(
        Constants.LS_PANORAMICA_COLUMNS_RESTORE,
        JSON.stringify(columns)
      );
    },
    setColumns(columns, skipSave = false) {
      this.skipSavePanoramicaColumns = skipSave;
      this.svincolatiCollapsed = columns.svincolatiCollapsed;
      this.planCollapsed = columns.planCollapsed;
      this.chatCollapsed = columns.chatCollapsed;
      this.partecipantiCollapsed = columns.partecipantiCollapsed;
      this.$nextTick(() => {
        this.skipSavePanoramicaColumns = false;
      });
    },
    toggleAllColumns() {
      if (this.panoramicaFocusActive) {
        this.focusModeActive = false;
        this.setColumns(this.getColumnsToRestore());
        return;
      }

      this.saveColumnsToRestore(this.currentColumns());
      this.focusModeActive = true;
      this.setColumns(
        {
          svincolatiCollapsed: true,
          planCollapsed: true,
          chatCollapsed: true,
          partecipantiCollapsed: false,
        },
        true
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.v-application .layout-panoramica-card {
  box-sizing: border-box;
  height: 100%;
  position: relative;
  padding-top: 16px;
  display: flex;
  flex-direction: column;
  overflow: visible;
  background-color: var(--dark_topbar) !important;
}

.layout-panoramica-body {
  flex: 1;
  display: flex;
  min-height: 0;
  overflow: hidden;
  position: relative;
}

.layout-panoramica-side-toolbar {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  justify-content: flex-start;
  padding: 10px;
}

.layout-panoramica-focus-exit {
  position: absolute;
  z-index: 3;
  bottom: 8px;
  left: 8px;
  border-radius: 6px;
  background-color: var(--dark_card_btn) !important;
  box-shadow: 0 0 0 1px var(--v-secondary-base) inset,
    0px 0px 12px 2px rgba(246, 189, 0, 0.8);
}

.layout-panoramica-toolbar-enter-active,
.layout-panoramica-toolbar-leave-active,
.layout-panoramica-focus-exit-enter-active,
.layout-panoramica-focus-exit-leave-active {
  transition: opacity 0.22s ease, transform 0.22s ease;
}

.layout-panoramica-toolbar-enter,
.layout-panoramica-toolbar-leave-to {
  opacity: 0;
  transform: translateX(-10px);
}

.layout-panoramica-focus-exit-enter,
.layout-panoramica-focus-exit-leave-to {
  opacity: 0;
  transform: translateX(-6px);
}

.layout-panoramica-side-panel {
  flex: 0 0 342px;
  position: relative;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  transition: flex-basis 0.18s ease;
}

.layout-panoramica-side-panel.collapsed {
  flex-basis: 0;
}

.layout-panoramica-plan {
  flex-basis: 260px;
  max-width: 260px;
  border-left: 1px solid rgba(255, 255, 255, 0.06);
  border-right: 1px solid rgba(255, 255, 255, 0.06);
}

.layout-panoramica-svincolati-chat {
  flex-basis: 305px;
  max-width: 305px;
  display: flex;
  flex-direction: column;
  border-right: 1px solid rgba(255, 255, 255, 0.06);
}

.layout-panoramica-svincolati-chat-section {
  flex: 1 1 0;
  min-height: 0;
  overflow: hidden;
}

.layout-panoramica-svincolati-chat--split .layout-panoramica-svincolati {
  flex-grow: 3;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.layout-panoramica-svincolati-chat--split .layout-panoramica-chat {
  flex-grow: 2;
}

.layout-panoramica-body::v-deep .rose-lega {
  flex: 1;
  min-width: 0;
}

.layout-panoramica-side-panel::v-deep > div,
.layout-panoramica-side-panel::v-deep .svincolati,
.layout-panoramica-side-panel::v-deep .plan {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.layout-panoramica-svincolati-chat-section::v-deep > div {
  height: 100%;
  min-height: 0;
}

.layout-panoramica-side-panel::v-deep .svincolati-list {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.layout-panoramica-side-panel::v-deep .svincolati-list > div {
  height: 100%;
  min-height: 0;
}

.layout-panoramica-side-panel::v-deep .svincolati-list .recycle-scroller {
  height: 100% !important;
}
.layout-panoramica-side-toolbar-btn{
      border-radius: 6px;
}

.layout-panoramica-side-toolbar-badge::v-deep .v-badge__badge {
  font-size: 10px;
  height: 16px;
  line-height: 16px;
  min-width: 16px;
  padding: 0 4px;
}

.layout-panoramica-side-toolbar-badge-new::v-deep .v-badge__badge {
  color: white;
  font-size: 8px;
  font-weight: 700;
  height: 13px;
  letter-spacing: 0;
  line-height: 13px;
  min-width: 20px;
  padding: 0 3px;
  text-transform: uppercase;
}

.layout-panoramica-side-toolbar-bottom {
  width: 100%;
  margin-top: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.layout-panoramica-side-toolbar-divider {
  width: 100%;
}

.layout-panoramica-chat-content {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.layout-panoramica-chat-messages {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.layout-panoramica-chat-input {
  flex: 0 0 auto;
  padding: 8px;
}

.layout-panoramica-chat-messages::v-deep .chat {
  height: 100%;
  min-height: 0;
}

.layout-panoramica-chat-messages::v-deep .chat-panel {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: flex-end;
  min-height: 0;
  overflow: hidden;
}

.layout-panoramica-chat-messages::v-deep .chat-messages {
  flex: 0 1 auto;
  height: auto;
  max-height: 100%;
  min-height: 0;
}

.layout-panoramica-chat-input::v-deep .chat-area-input {
  max-width: none;
}

.layout-panoramica-plan::v-deep .plan-content {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.layout-panoramica-plan::v-deep .recycle-scroller {
  flex: 1;
  min-height: 0;
  height: auto !important;
  overflow-y: auto;
}

.layout-panoramica-plan::v-deep .titolo {
  padding-right: 32px;
}

.v-main {
  height: 100vh;
  box-sizing: border-box;
  background-color: var(--dark_main_bk);
}
</style>
